import { render, staticRenderFns } from "./BankTransferPaidToAccount.vue?vue&type=template&id=6ba10593&"
import script from "./BankTransferPaidToAccount.vue?vue&type=script&lang=ts&"
export * from "./BankTransferPaidToAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports